import React, { useContext, useMemo } from 'react';
import moment from 'moment';
import { List } from 'antd';
import SessionContext from '@providers/Session/SessionContext';

import * as S from './styles';

export interface MessageData {
  worklogId: number;
  note: string;
  objectId: number;
  objectTypeId: number;
  objectTypeName: string;
  createdBy: string;
  createAt: string;
  restrictionTypeName: string;
  restrictionTypeDescription: string;
}

interface MessagesListProps {
  messages: MessageData[];
}

const MessagesList = ({ messages }: MessagesListProps) => {
  const { userLogged } = useContext(SessionContext);

  const treatedMessages = useMemo(
    () => messages?.filter(message => !message?.note?.includes('Remote Host')),
    [messages],
  );

  return (
    <S.MessagesListContainer>
      <List
        dataSource={treatedMessages}
        renderItem={messageItem => {
          const createdAt = moment(messageItem?.createAt).format('HH:mm:ss');
          const isMyMessage =
            messageItem?.createdBy === userLogged?.preferred_username;

          return (
            <List.Item>
              <S.MessagesListContent isMyMessage={isMyMessage}>
                <div className="list-item-header">
                  <span className="list-item-created-by">
                    {messageItem?.createdBy}
                  </span>
                  <span className="list-item-create-at">{createdAt}</span>
                </div>
                <span className="list-item-note">{messageItem?.note}</span>
              </S.MessagesListContent>
            </List.Item>
          );
        }}
      />
    </S.MessagesListContainer>
  );
};

export default MessagesList;
